import { render } from "./AccountContainer.vue?vue&type=template&id=c03ad9b8"
import script from "./AccountContainer.vue?vue&type=script&lang=js"
export * from "./AccountContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__